import React from 'react';

import {ListViewImage} from './ListViewImage.jsx';
import {ListViewButtonSet} from './ListViewButtonSet.jsx';
import {ListViewContentLeft} from './ListViewContentLeft.jsx';
import {ListViewContentRight} from './ListViewContentRight.jsx';

var ListTheme  = React.createClass({
  makeActive: function(slug){
    this.props.makeActive(slug);
  },
  showPreview: function(slug){
    this.props.showPreview(slug);
  },
  editTheme: function(slug, accountSlug, type){
    this.props.editTheme(slug, accountSlug, type);
  },
  popup: function(value){
    // this.props.popup(value); // for opens popup when click on activate
  },
  isClicked: function(){
    this.props.isClicked();
  },
  render: function(){
    var showButton;
    if(this.props.themes != undefined){
      var themes = this.props.themes.map(function(value,index){
         if(value["type"] == "VIEWLAYOUT")
          {
            showButton = false;
          }
          else{
            showButton = true;
          }
          if(this.props.active == value["name"]){
            return(
                  <article className="theme-list active clearfix" key = {index}>
                    <div className="whole">
                      <ListViewImage value = {value} />
                      <ListViewButtonSet  value= {value} 
                                          showPreview = {this.showPreview} 
                                          editTheme = {this.editTheme}
                                          libName = {this.props.libName} 
                                          showButton = {showButton} />
                      <div className="theme-list__second-col clearfix">
                       <ListViewContentLeft value = {value} 
                                            active = {this.props.active}
                                            showButton = {showButton}
                                            popup = {this.popup} />
                        <ListViewContentRight value = {value}
                                              libName = {this.props.libName} />
                      </div>
                    </div>
                  </article>
              );
          }
        else{
          return(
            <article className="theme-list clearfix" key = {index}>
              <div className="whole">
                <ListViewImage value = {value} />
                <ListViewButtonSet  value= {value} 
                                    showPreview = {this.showPreview} 
                                    editTheme = {this.editTheme}
                                    libName = {this.props.libName}
                                    showButton = {showButton} />
                <div className="theme-list__second-col clearfix">
                  <ListViewContentLeft  value = {value} 
                                        makeActive = {this.makeActive} 
                                        active = {this.props.active}
                                        showButton = {showButton}
                                        popup = {this.popup} />
                  <ListViewContentRight value = {value} 
                                        libName = {this.props.libName}/>
                </div>
              </div>
            </article>
          );
        }
      },this);
    }
    return(
      <div>
        {themes}
      </div>
    );
  }
});

export {ListTheme};


/** WEBPACK FOOTER **
 ** ./html/components/ListTheme.jsx
 **/